import { Link } from 'react-router-dom';
import styled from 'styled-components';
// Imported from src so the bundler content-hashes the file — cache-busts the
// logo on deploy so a stale CDN copy can't keep showing an old image.
import yakiImage from '../../main.png';

const FooterContainer = styled.footer`
  width: 100%;
  flex: none;
  background: color-mix(in oklch, ${({ theme }) => theme.surface} 88%, transparent);
  color: ${({ theme }) => theme.textMuted};
  font-family: ${({ theme }) => theme.fontBody};
  font-weight: 650;
  padding: 10px 28px;
  border-top: 1px solid ${({ theme }) => theme.border};
  box-shadow: none;
  position: relative;
  bottom: 0;
`;

const FooterContent = styled.div`
  max-width: 1240px;
  margin: 0 auto;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  font-size: ${({ theme }) => theme.fsSm};

  @media (max-width: 600px) {
    font-size: 11px;
    gap: 4px;
    justify-content: center;
    flex-wrap: wrap;
  }
`;

const FooterLink = styled.a`
  color: ${({ theme }) => theme.textMuted};
  text-decoration: none;
  transition: color 0.2s;

  &:hover {
    color: ${({ theme }) => theme.accentStrong};
  }
`;

const Separator = styled.span`
  color: #999;
`;

const LogoWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

const Image = styled.img`
  width: 18px;
  height: 18px;
  border-radius: 2px;
  object-fit: cover;
  mix-blend-mode: multiply;

  @media (max-width: 600px) {
    width: 14px;
    height: 14px;
  }
`;

const Line = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 0;
  background-color: transparent;
`;

const Footer = () => {
  return (
    <FooterContainer>
      <Line />
      <FooterContent>
        <FooterLink as={Link} to="#">Terms of Use</FooterLink>
        <Separator>|</Separator>
        <FooterLink
          href="https://studyak.ai/privacy-policy/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </FooterLink>
        <Separator>|</Separator>
        <LogoWrapper>
          Powered by Studyak
          <Image
            src={yakiImage}
            alt="Studyak Logo"
          />
        </LogoWrapper>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;
